<label>Enter Username:</label>
<input
    type="text"
    class="form-control"
    (input)="checkUsername()"
    [(ngModel)]="username">

    <button
    class="btn btn-primary"
    [disabled]="disableButton"
    (click)="clearUsername()"
    >Create</button>

<p [ngStyle]="{color: getColor()}">{{ msg }}</p>